<template>
  <div class="kongjian">
    <a-row style="height: 100%">
      <a-col :span="17" style="height: 100%">
        <ShowWpsFile ref="showWpsFile" :btnShow="false" :fileCode="code" :isReadOnly="'false'" />
      </a-col>
      <a-col :span="7">
        <a-form :form="form">
          <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            :label="currAuditStatus == 9 || currAuditStatus == 10 ? '校稿结论：' : '审稿结论：'"
          >
            <a-select placeholder="请选择" @change="resultChange" name="result" v-model="result">
              <a-select-option :value="5" v-if="currAuditStatus == 4"> 送主编审核 </a-select-option>
              <a-select-option :value="7" v-if="currAuditStatus == 5"> 送交外审 </a-select-option>
              <a-select-option :value="6" v-if="currAuditStatus == 5 || currAuditStatus == 8">
                审核通过
              </a-select-option>
              <a-select-option :value="10" v-if="currAuditStatus == 9"> 送主编校对 </a-select-option>
              <a-select-option :value="11" v-if="currAuditStatus == 10"> 校对完成 </a-select-option>
              <a-select-option :value="33">退改</a-select-option>
              <a-select-option :value="44">退稿</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            label="外审专家："
            v-if="result == 7"
          >
            <a-select placeholder="请选择" @change="getExpertCode" v-if="showExpertInfo" v-model="expertCode">
              <a-select-option v-for="ept in expertData" :key="ept.expertCode">
                {{ ept.name }}
              </a-select-option>
            </a-select>
            <a-input type="text" placeholder="请选择" v-if="!showExpertInfo" disabled />
          </a-form-item>
          <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            label="要求审回日期："
            v-if="result == 7"
          >
            <a-date-picker v-if="showExpertInfo" :value="date" @change="dateChange" />
            <a-date-picker v-if="!showExpertInfo" disabled />
          </a-form-item>
          <!-- <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            label="审稿费："
            v-if="result == 7"
          >
            <a-select
              style="width: 100px"
              v-model="price"
              v-if="showInputPrice"
              @change="priceChange"
            >
              <a-select-option v-for="item in priceList" :key="item.dicValue">
                {{ item.dicValue }}
              </a-select-option>
            </a-select>
            <a-input
              placeholder="请输入审稿费"
              v-model="price"
              v-if="!showInputPrice"
              :disabled="!showExpertInfo"
            />
          </a-form-item> -->
          <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            :label="currAuditStatus == 9 || currAuditStatus == 10 ? '校稿意见：' : '审稿意见：'"
          >
            <a-textarea placeholder="请输入" id="note" v-model="note" :autoSize="{ minRows: 4, maxRows: 8 }" />
          </a-form-item>
          <a-form-item
            :label-col="formSelectLayout.labelCol"
            :wrapper-col="formSelectLayout.wrapperCol"
            v-if="manuscript.result != 0"
            :label="manuscript.result == 33 ? '退改意见：' : '退稿意见：'"
          >
            <div>{{ manuscript.auditOpinion }}</div>
          </a-form-item>
        </a-form>
        <div class="btn_div">
          <a-button class="manager_but" @click="cancel"> 关闭 </a-button>
          <a-button class="manager_but" @click="save"> 保存 </a-button>
          <a-button class="manager_but" type="primary" @click="submit"> 提交 </a-button>
        </div>
        <div class="btn_div">注：修改文档后使用Ctrl + S 保存文档</div>
        <div class="btn_div">
          <a-button id="preview" name="btn" @click="previewFile"> 文档预览 </a-button>
        </div>
      </a-col>
    </a-row>
    <PreviewCreateFile
      ref="previewCreateFile"
      :fileId="code"
      @previewFileClose="
        () => {
          this.$refs.showWpsFile.openWps();
        }
      "
    />
  </div>
</template>
<script>
import qs from "qs";
import moment from "moment";
import ShowWpsFile from "../../../commomon/ShowWpsFile.vue";
import PreviewCreateFile from "../../../commomon/PreviewCreateFile.vue";
export default {
  name: "Manager",
  data() {
    return {
      code: "",
      currAuditStatus: 4,
      showInputPrice: true,
      date: null,
      endDate: "",
      note: "",
      price: "0",
      result: "",
      status: 2,
      expertCode: "",
      oldOpinionCode: "",
      expertData: [],
      priceList: [],
      showExpertInfo: true,
      form: {},
      formSelectLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 14 },
      },
      previewVisible: false,
      spinning: false,
      manuscript: {},
    };
  },
  components: {
    ShowWpsFile,
    PreviewCreateFile,
  },
  created() {
    this.code = this.$route.query.code;
    this.currAuditStatus = this.$route.query.auditStatus; // 稿件当前审核状态
    this.queryExpert();
    this.queryAuditOpinion();
  },
  mounted() {
    this.axios
      .get("/manuscripts/queryByCode", {
        params: {
          code: this.code,
          time: new Date().getTime(),
        },
        paramsSerializer: function (p) {
          return qs.stringify(p, { arrayFormat: "repeat" });
        },
      })
      .then(res => {
        if (res.data.code == "OK") {
          this.manuscript = res.data.data;
        }
      });
  },
  methods: {
    moment,
    resultChange(result) {
      let _this = this;
      _this.result = result;
      _this.showExpertInfo = false;
      _this.showInputPrice = false;
      _this.expertCode = "";
      _this.price = "";
      _this.date = null;
      _this.note = "";
      _this.status = 2;
      if (result == 44) {
        this.note = "感谢来稿，未被采用。";
        this.status = 4;
      } else if (result == 33) {
        this.note = "请您修改稿件。";
        this.status = 3;
      } else if (_this.result == 7) {
        _this.showExpertInfo = true;
        _this.showInputPrice = true;
        _this.price = "0";
      }
    },
    submit() {
      this.audit(1);
    },
    save() {
      this.audit(0);
    },
    audit(status) {
      let _this = this;
      if (_this.result == 7) {
        if (_this.expertCode === "") {
          this.$notification["warning"]({
            message: "提示",
            description: "请选择外审专家！",
          });
          return false;
        }
      }
      if (_this.result === "") {
        this.$notification["warning"]({
          message: "提示",
          description: "请选择审稿结论！",
        });
        return false;
      }
      _this.$refs.showWpsFile.saveDoc(-1);
      _this.axios
        .post("/auditOpinion/saveAuditOpinion", {
          code: _this.code,
          auditer: sessionStorage.getItem("userCode"),
          note: _this.note,
          result: _this.result,
          status: _this.status,
          oldOpinionCode: _this.oldOpinionCode,
          evalData: [],
          expertCode: _this.expertCode == null ? "" : _this.expertCode,
          endDate: _this.endDate,
          price: _this.price,
          isSubmit: status,
        })
        .then(res => {
          if (res.data.code == "OK") {
            if (status == 0) {
              _this.$router.go(-1);
            } else {
              _this.$router.push("/auditing");
            }
          } else {
            this.$notification["warning"]({
              message: "提示",
              description: res.data.data,
            });
          }
        });
    },
    cancel() {
      this.$router.go(-1);
    },
    dateChange(date, dateString) {
      this.endDate = dateString;
      this.date = date;
    },
    queryExpert() {
      let _this = this;
      _this.axios
        .get("/expertInfo/queryExpertInfo", {
          params: {
            name: _this.queryExpertName,
            sortField: "expert_num",
            sortType: "desc",
            page: 1,
            limit: 100,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "0") {
            _this.expertData = res.data.data;
          } else {
            _this.utils.messageInfo(_this, "error", "查询专家列表失败！");
          }
        });
    },
    queryPriceList() {
      let _this = this;
      _this.axios
        .get("/dataDic/queryChild", {
          params: {
            parentCode: "expert_audit_price",
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          _this.priceList = res.data;
        });
    },
    getExpertCode(expertCode) {
      this.expertCode = expertCode;
    },
    queryAuditOpinion() {
      let _this = this;
      _this.axios
        .get("/auditOpinion/queryAuditOpinion", {
          params: {
            code: _this.code,
            isSubmit: 0,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "OK") {
            var auditOpinion = res.data.data.auditOpinion;
            if (auditOpinion.length > 0) {
              _this.result = auditOpinion[0].result;
              if (_this.result == 7) {
                this.resultChange(7);
              }
              _this.note = auditOpinion[0].note;
              if (auditOpinion[0].result === 6) {
                _this.showExpertInfo = true;
              }
              _this.oldOpinionCode = auditOpinion[0].opinionCode;
              if (_this.result == 33) {
                _this.status = 3;
                if (_this.note == "") {
                  _this.note = "请您修改稿件。";
                }
              } else if (_this.result == 44) {
                _this.status = 4;
                if (_this.note == "") {
                  _this.note = "感谢来稿，未被采用。";
                }
              }
            }
            var dataoutAuditInfo = res.data.data.outAuditInfo;
            if (dataoutAuditInfo != null && dataoutAuditInfo.code != null) {
              _this.expertCode = dataoutAuditInfo.expertCode;
              if (dataoutAuditInfo.endDate != "" && dataoutAuditInfo.endDate != null) {
                _this.endDate = dataoutAuditInfo.endDate;
                _this.date = moment(_this.endDate, "YYYY-MM-DD");
              }
              _this.price = dataoutAuditInfo.price;
              var expertName = "";
              _this.expertData.forEach(function (value) {
                if (dataoutAuditInfo.expertCode == value.expertCode) {
                  value.selected = 1;
                  expertName = value.name;
                }
              });
              _this.expertName = expertName;
              _this.name = expertName;
            }
          }
        });
    },
    priceChange(price) {
      if (price === "其他金额") {
        this.showInputPrice = false;
        this.price = "";
      }
    },
    previewFile() {
      this.$refs.previewCreateFile.previewFile();
    },
  },
};
</script>
<style>
.kongjian {
  height: 100%;
  background-color: #fff;
}
.kongjian .btn_div {
  text-align: center;
  margin-top: 10px;
}
.kongjian .btn_div button {
  margin: 0 5px;
}
.kongjian .title {
  height: 36px;
  line-height: 36px;
  text-align: right;
}
</style>
